import type {
  GetBillingAccountOverviewResponse,
  IssueCreditBody,
} from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { subscriptionKeys } from "@/hooks/queryKeys";

import { addCredit } from "../../overview/utils/account-overview-cache";

export function useIssueCredit(
  projectId: number,
): UseMutationResult<IssueCreditBody, Error, IssueCreditBody> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (credit: IssueCreditBody) => credit,
    onSuccess: (credit) => {
      queryClient.setQueryData<GetBillingAccountOverviewResponse>(
        subscriptionKeys.accountOverview(projectId),
        (overview) => overview && addCredit(overview, credit.amount),
      );

      toast.add({
        description: "The credit will be drawn against the next invoice.",
        timeout: 3000,
        title: "Credit issued",
        type: "success",
      });
    },
  });
}
